import React, { createContext, useContext, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  deleteLogonInfoFromCookies,
  getLogonInfoFromCookies,
} from "../utils/util";
import { AuthResponse } from "../services/Models/AuthModel";

// tipo del contesto
interface AuthContextType {
  isAuthenticated: boolean;
  performLogin: (redirectUrl?: string) => void;
  performLogout: (option?: any) => void;
  requireAuth: (path: string) => void;
  redirectPath: string | null;
}

// Creazione del contesto
const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  performLogin: () => {},
  performLogout: () => {},
  requireAuth: () => {},
  redirectPath: null,
});

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const loginResult = useRef<AuthResponse>(getLogonInfoFromCookies());
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    loginResult.current ? true : false
  );
  const [redirectPath, setRedirectPath] = useState<string | null>(null);
  const navigate = useNavigate();

  const performLogin = (redirectUrl?: string) => {
    setIsAuthenticated(true);
    setRedirectPath(null);
    if (redirectUrl) navigate(redirectUrl);
  };

  const performLogout = (option?: any) => {
    deleteLogonInfoFromCookies();
    localStorage.removeItem("image");
    localStorage.removeItem("filterList");
    // localStorage.removeItem("authToken");
    setIsAuthenticated(false);
    setRedirectPath(null);
    navigate("/logout", option);
  };

  const requireAuth = (path: string) => {
    if (!isAuthenticated) {
      setRedirectPath(path); // Salva il percorso richiesto
      navigate("/"); // Reindirizza alla login
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        performLogin,
        performLogout,
        requireAuth,
        redirectPath,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
